import { Injectable, signal } from '@angular/core';
import { apiEndpoints } from './general.common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfirmOrchestrationResponse, InitiateSessionRequest, OrchestrationResponse, RefreshSessionRequest } from '../general.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

diasporaSessionToken = signal<string | null | undefined>(localStorage.getItem('token'));
setDiasporaSessionToken(token: string | null | undefined): void {
    this.diasporaSessionToken.set(token);
}

quoteDetails = signal<OrchestrationResponse | null | undefined>(null);

setQuoteDetails(orchestrationResponse: OrchestrationResponse | null | undefined): void {
    this.quoteDetails.set(orchestrationResponse);
}

confirmTransactionResponse = signal<ConfirmOrchestrationResponse | null | undefined>(null);

setConfirmTransactionResponse(confirmOrchestrationResponse: ConfirmOrchestrationResponse | null | undefined): void {
    this.confirmTransactionResponse.set(confirmOrchestrationResponse);
}


uuid = signal<string | null | undefined>(null);

setUUID(uuid: string | null | undefined): void {
    this.uuid.set(uuid);
}



headers: HttpHeaders = new HttpHeaders().set('Content-Type', 'application/json').set('Cache-Control', 'no-cache');

constructor(private http: HttpClient) { }

initiate(initiateSessionRequest: InitiateSessionRequest): Observable<any> {
    return this.http.post<any>(apiEndpoints.initiate(), initiateSessionRequest, { headers: this.headers });
}


refresh(refreshSessionRequest: RefreshSessionRequest): Observable<any> {
    return this.http.post<any>(apiEndpoints.refresh(), refreshSessionRequest, { headers: this.headers });
}

}
